module.exports = __webpack_public_path__ + "img/brazil_woman.950c2204.svg";